import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';
import { Dialog, Button, Form, Input, Select, Message } from 'element-react';
import http from '../../utils/request'
import { getCookie } from '../../utils/cookie'

class CommonDialog extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dialogVisible3: false,
      form: {
        content: '',
        mobile: '',
        code: ''
      },
      rules: {
        content: [
          { required: true, message: '请输入咨询内容及说明', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9]|191)[0-9]{8}$/,
            message: '请输入有效的手机号！',
          }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      codeText: '获取验证码',
      dialogData: '',
      hasToken: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.dialogData != prevState.dialogData) {
      return {
        dialogData: nextProps.dialogData,
      }
    }
    return null;
  }

  componentDidMount() {
    const cookie = getCookie('userinfo') ? JSON.parse(getCookie('userinfo')) : '';
    const token = cookie ? cookie.token : '';
    if (token) {
      this.setState({
        hasToken: true
      })
    }
  }

  componentWillUnmount(){
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  // 关闭模态框
  handleCancel = () => {
    this.setState({ 
      dialogVisible3: false,
    })
    this.refs.form.resetFields();
    if (this.timer) {
      clearInterval(this.timer);
      this.setState({
        codeText: '获取验证码'
      })
    }
  }

  // 获取验证码
  getCode = () => {
    const { form, codeText } = this.state;
    if (codeText != '获取验证码') {
      return
    }
    const that = this;
    if (form.mobile) {
      http('post', '/achieve/user/sms', { mobile: form.mobile }).then(res => {
        if (res.code === 200) {
          let counter = 60;
          that.timer = setInterval(() => {
            counter -= 1;
            that.setState({
              codeText: counter + 's后重新获取'
            })
            if (counter === 0) {
              clearInterval(that.timer);
              that.setState({
                codeText: '获取验证码'
              })
            }
          }, 1000)
        } else {
          Message({
            type: 'error',
            message: res.msg,
            duration: 2000,
            customClass: 'zZindex'
          })
        }
      })
    } else {
      Message({
        type: 'warning',
        message: '请先填写手机号!',
        duration: 2000,
        customClass: 'zZindex'
      })
    }
  }

  handleChange = (e, key) => {
    const { form } = this.state;
    form[key] = e;
    this.setState({
      form
    })
  }

  // 提交按钮
  onSubmit = (e) => {
    e.preventDefault();
    const that = this;
    this.refs.form.validate((valid) => {
      if (valid) {
        const { dialogData, form } = this.state;
        const cookie = getCookie('userinfo') ? JSON.parse(getCookie('userinfo')) : '';
        const token = cookie ? cookie.token : '';
        const data = { ...dialogData, ...form, token };
        http('post', '/achieve/detail/consult', data).then(res => {
          if (res.code === 200) {
            Message({
              type: 'success',
              message: res.msg,
              duration: 3000,
              customClass: 'zZindex'
            })
            that.setState({ dialogVisible3: false })
            that.refs.form.resetFields();
            if (that.timer) {
              clearInterval(that.timer);
              that.setState({
                codeText: '获取验证码'
              })
            }
          } else {
            Message({
              type: 'error',
              message: res.msg,
              duration: 3000,
              customClass: 'zZindex'
            })
          }
        })
      } else {
        return false;
      }
    });
  }

  render() {
    const { dialogData } = this.state;

    return (
      <div className="dialog">
        <Button
          type="text"
          className="link"
          onClick={() => this.setState({ dialogVisible3: true })}
          disabled={dialogData.status === 1 ? false : true}
        >详情咨询</Button>
        <Dialog
          title="详情咨询"
          visible={this.state.dialogVisible3}
          onCancel={() => this.handleCancel()}
        >
          <Dialog.Body>
            <Form ref="form" model={this.state.form} rules={this.state.rules}>
              <Form.Item label="技术/成果名称：" labelWidth="150">
                <p className="dialog__title">{dialogData ? dialogData.title : ''}</p>
              </Form.Item>
              <Form.Item prop="content" label="咨询内容及说明：" labelWidth="150">
                <Input
                  type="textarea"
                  autosize={{ minRows: 4, maxRows: 5 }}
                  placeholder=""
                  onChange={e => this.handleChange(e, 'content')}
                  value={this.state.form.content}
                />
                <p className="dialog__tip"><span>*</span>提交申请后工作人员会与您取得联系，请保持电话畅通</p>
              </Form.Item>
              {/* <Form.Item label="咨询内容及说明：" labelWidth="140">
                <Select value={this.state.form.region} placeholder="请选择活动区域">
                  <Select.Option label="区域一" value="shanghai"></Select.Option>
                  <Select.Option label="区域二" value="beijing"></Select.Option>
                </Select>
              </Form.Item> */}
              {
                !this.state.hasToken && (
                  <Form.Item prop="mobile" label="手机号：" labelWidth="150">
                    <Input value={this.state.form.mobile} onChange={e => this.handleChange(e, 'mobile')}></Input>
                  </Form.Item>
                )
              }
              {
                !this.state.hasToken && (
                  <Form.Item prop="code" label="验证码：" labelWidth="150">
                    <Input value={this.state.form.code} onChange={e => this.handleChange(e, 'code')} append={<Button type="primary" onClick={this.getCode}>{this.state.codeText}</Button>}></Input>
                  </Form.Item>
                )
              }
            </Form>
          </Dialog.Body>

          <Dialog.Footer className="dialog-footer">
            <Button type="primary" onClick={this.onSubmit}>提交</Button>
          </Dialog.Footer>
        </Dialog>
      </div>
    )
  }
}

export default connect(null, null)(CommonDialog);

